var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12269_11897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4882 25.5262C37.2468 24.4295 41.8366 18.0616 40.7399 11.303C39.6432 4.54448 33.2753 -0.0453528 26.5167 1.05135C19.7582 2.14806 15.1684 8.516 16.2651 15.2745C17.3618 22.0331 23.7297 26.6229 30.4882 25.5262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4082 42.8387C1.4082 50.1596 7.35761 56.109 14.6785 56.109H42.3236C49.6445 56.109 55.5939 50.1596 55.5939 42.8387C55.5939 35.5178 49.6445 29.5684 42.3236 29.5684H14.6785C7.35761 29.5684 1.4082 35.5178 1.4082 42.8387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12269_11897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorProfile);
export default __webpack_public_path__ + "static/media/color_profile.baac39b19e36ca1b5f6b87d48385bc50.svg";
export { ForwardRef as ReactComponent };